<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [noSubmit]="true"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="footer">
    <ssg-menu icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div class="report-box">
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
